import React from 'react';

import { Button } from 'react-bootstrap';
import { useIntl } from 'react-intl';

import { SolidCircleIcon, LightbulbIcon, CloseIcon } from 'assets/icons';

interface SuggestionBannerProps {
  suggestedDevices: IDeviceOrderingCatalogItem[];
  onAccept: () => void;
  onDismiss: () => void;
}

export const SuggestionBanner = ({
  suggestedDevices,
  onAccept,
  onDismiss
}: SuggestionBannerProps) => {
  const intl = useIntl();

  if (suggestedDevices.length === 0) return null;

  return (
    <div
      className="position-relative rounded mb-4 p-3 suggestion-banner"
      data-test="suggestion-banner"
    >
      <div className="d-flex align-items-start gap-3">
        <span
          className="flex-shrink-0 position-relative d-inline-flex align-items-center justify-content-center"
          style={{ color: '#1D9E75' }}
        >
          <SolidCircleIcon className="icon" style={{ fontSize: '32px' }} />
          <LightbulbIcon
            className="icon position-absolute text-white"
            style={{ fontSize: '16px' }}
          />
        </span>

        <div className="flex-grow-1 pe-4">
          <p className="mb-1 fw-medium">{intl.formatMessage({ id: 'deviceSuggestionTitleKey' })}</p>
          <p className="mb-2 small text-secondary">
            {intl.formatMessage({ id: 'deviceSuggestionDescriptionKey' })}
          </p>
          <div className="d-flex flex-wrap gap-2">
            {suggestedDevices.map((device) => (
              <span key={device.sku} className="rounded-pill px-3 py-1 bg-light border small">
                {intl.formatMessage({ id: device.displayName, defaultMessage: device.displayName })}
              </span>
            ))}
          </div>
        </div>

        <Button
          variant="primary"
          size="sm"
          onClick={onAccept}
          className="flex-shrink-0 align-self-center text-nowrap rounded-3"
          data-test="suggestion-accept-btn"
        >
          {intl.formatMessage({ id: 'deviceSuggestionAcceptKey' })}
        </Button>
      </div>

      <Button
        variant="link"
        onClick={onDismiss}
        className="position-absolute d-flex align-items-center justify-content-center rounded-circle p-0 text-secondary"
        style={{ top: 8, right: 8, width: 28, height: 28 }}
        aria-label="Dismiss"
        data-test="suggestion-dismiss-btn"
      >
        <CloseIcon className="icon" style={{ fontSize: '14px' }} />
      </Button>
    </div>
  );
};
